import React, {Component} from 'react'
import {Form, Input, Header, Icon, Select} from 'semantic-ui-react'
import countries from 'get-countries-info';
import postal from "postal-abbreviations";

class AccountAddress extends Component {

    constructor(props) {
        super(props)
        this.state = {
            selectedState: props.data.state || "",
            selectedCountry: props.data.country || "USA"
        }
    }

    handleCountryChange = (e, {value}) => {
        this.setState({selectedCountry: value})
        this.props.change('country', value)
    }
    handleStateChange = (e, {value}) => {
        this.setState({selectedState: value})
        this.props.change('state', value)
    }

    handleChange = (e) => {
        this.props.change(e.target.name, e.target.value)
    }

    render() {
        let countryList = countries({}).map(country => {
            let data = {
                key: country.ISO.alpha2 + country.ISO.alpha3,
                text: country.name,
                value: country.ISO.alpha3,
                flag: country.ISO.alpha2.toLowerCase()
            }
            return data
        })
        let countrySelected = countries({ISO: this.state.selectedCountry})

        let states = countrySelected[0].provinces !== null ? countrySelected[0].provinces.map((state, index) => {
            return {key: index, text: state, value: postal(state) || state}
        }) : null
        return (
            <div>
                <Header as='h3' dividing>
                    <Icon name='location arrow'/>
                    <Header.Content>
                        Account Address
                        <Header.Subheader>
                            Manage your address
                        </Header.Subheader>
                    </Header.Content>
                </Header>
                <Form.Field control={Input} label='Address Line 1' placeholder='Address Line 1'
                            value={this.props.data.address1}
                            name='address1' onChange={this.handleChange.bind(this)}/>
                <Form.Field control={Input} label='Address Line 2' placeholder='Address Line 2'
                            value={this.props.data.address2}
                            name='address2' onChange={this.handleChange.bind(this)}/>
                <Form.Field control={Input} label='City' placeholder='City' value={this.props.data.city}
                            name='city' onChange={this.handleChange.bind(this)}/>
                {
                    states !== null ? <Form.Field control={Select} label='State' fluid search selection
                                                  options={states}
                                                  value={this.state.selectedState}
                                                  placeholder='State'
                                                  onChange={this.handleStateChange.bind(this)}
                                                  autoComplete='state'/> : null
                }
                <Form.Field control={Input} label='Zip Code' placeholder='Zip Code' value={this.props.data.zip}
                            name='zip' onChange={this.handleChange.bind(this)}/>
                <Form.Field control={Select} label='Country' fluid search selection
                            readOnly={true}
                            options={countryList} value={this.state.selectedCountry}
                            placeholder='Country'
                            onChange={this.handleCountryChange.bind(this)}
                            autoComplete='country-name'/>


            </div>
        )
    }
}

export default AccountAddress


// WEBPACK FOOTER //
// ./src/containers/register/AccountAddress.js